import request from '@/utils/request'
export const queryPage = '/icps/system/sign/basics/plan/queryOutsourcingPullerPage'

/*获取泵机车牌号*/
export function getPumpNoList(params) {
    return request({
        url: '/icps/system/sign/intelligent/departure/getPumpNoList',
        method: 'get',
        params
    })
}

/*接力泵补录*/
export function updateApplyDetList(data) {
    return request({
        url: '/icps/system/sign/intelligent/departure/updateApplyDetList',
        method: 'post',
        data
    })
}


/*操作补录*/
export function updateApplyDet(data) {
    return request({
        url: '/icps/system/sign/intelligent/departure/updateApplyDet',
        method: 'post',
        data
    })
}